
var product_id=3;
var currentAudio = null;
var isPlaying = false;
var isDragging = false;
var currentAudioSrc = null;
var currentAudioFormat = null;
// 点击消失
$(document).click(function(){
    $('.voice-selector—list').hide()
})
// 切换语言后获取到的列表
$('.form-select').change(function(){
    $('.voice-selector—list').html('')
    for(var i=0;i<voices[$(this).val()].length;i++){
        var genderIcon = voices[$(this).val()][i].tag[0] === 'F'
            ? '<i class="gender-female"></i>'
            : '<i class="gender-male"></i>';
        $('.voice-selector—list').append(`
            <li data-tag="${voices[$(this).val()][i].tag[0]}">
                <div class="voice-item-content">
                    <div class="voice-item-text">
                        <p class="name" voice_id="${voices[$(this).val()][i].voice_id}">${voices[$(this).val()][i].voice_name}</p>
                        <p class="info">${voices[$(this).val()][i].description[0]}</p>
                    </div>
                    ${genderIcon}
                </div>
            </li>    
        `)
    }
    edit_voice($('.voice-selector—list').find('li').eq(0).find('.name').html(),$('.voice-selector—list').find('li').eq(0).find('.info').html(),$('.voice-selector—list').find('li').eq(0).find('.name').attr('voice_id'),voices[$(this).val()][0].tag[0])
    
    
    // 给第一个 li 添加选中状态
    $('.voice-selector—list li').removeClass('selected');
    $('.voice-selector—list').find('li').eq(0).addClass('selected');
})

$('.voice-selector').click(function(e){
    e.stopPropagation()
    $('.voice-selector—list').toggle()
})
$('.voice-selector—list').on('click','li',function(e){
    e.stopPropagation()
    
    // 移除所有 li 的选中状态
    $('.voice-selector—list li').removeClass('selected');
    
    // 添加当前 li 的选中状态
    $(this).addClass('selected');
    
    edit_voice($(this).find('.name').html(),$(this).find('.info').html(),$(this).find('.name').attr('voice_id'),$(this).data('tag'))
    $('.voice-selector—list').hide()
})

$('.voice-selector—list').find('li').eq(0).click()

function edit_voice(name,info,id,tag){
    console.log(id)
    var icon = '';
    if(tag === 'F'){
        icon = '<i class="gender-female"></i>';
    } else if(tag === 'M'){
        icon = '<i class="gender-male"></i>';
    }
    $('.voice-name').html(name + ' ' + icon)
    $('.voice-tags').html(info)
    $('.voice-info').attr('voice_id',id)
}

// 删除
$('#clear-text-btn').click(function(){
    $('#script-editor').html('');
    // 确保清空后 :empty 伪类生效，显示 placeholder
    var editor = document.getElementById('script-editor');
    if(editor.innerHTML === '' || editor.innerHTML === '<br>') {
        editor.innerHTML = '';
    }
    updateCharCount();
})

// ---- 富文本编辑器工具函数 ----
function getEditorText(){
    var editor = document.getElementById('script-editor');
    var text = '';
    editor.childNodes.forEach(function(node){
        if(node.nodeType === Node.TEXT_NODE){
            text += node.textContent;
        } else if(node.nodeType === Node.ELEMENT_NODE){
            if(node.classList && node.classList.contains('editor-chip')){
                text += node.getAttribute('data-tag');
            } else if(node.tagName === 'BR'){
                text += '\n';
            } else {
                text += node.innerText || node.textContent;
            }
        }
    });
    return text;
}

function updateCharCount(){
    var text = getEditorText();
    var maxLength = parseInt($('#max-text-count').text()) || 0;
    if(maxLength > 0 && text.length > maxLength){
        truncateEditor(maxLength);
        text = getEditorText();
    }
    $('#char-count #current-text-count').html(text.length);
}

function truncateEditor(maxLength){
    var editor = document.getElementById('script-editor');
    var remaining = maxLength;
    var nodesToRemove = [];

    for(var i = 0; i < editor.childNodes.length; i++){
        var node = editor.childNodes[i];
        if(remaining <= 0){
            nodesToRemove.push(node);
            continue;
        }
        if(node.nodeType === Node.TEXT_NODE){
            var len = node.textContent.length;
            if(len <= remaining){
                remaining -= len;
            } else {
                node.textContent = node.textContent.slice(0, remaining);
                remaining = 0;
            }
        } else if(node.nodeType === Node.ELEMENT_NODE){
            if(node.classList && node.classList.contains('editor-chip')){
                var chipTag = node.getAttribute('data-tag') || '';
                if(chipTag.length <= remaining){
                    remaining -= chipTag.length;
                } else {
                    nodesToRemove.push(node);
                    remaining = 0;
                }
            } else if(node.tagName === 'BR'){
                if(remaining > 0) remaining -= 1;
                else nodesToRemove.push(node);
            } else {
                var innerLen = (node.innerText || node.textContent).length;
                if(innerLen <= remaining){
                    remaining -= innerLen;
                } else {
                    nodesToRemove.push(node);
                    remaining = 0;
                }
            }
        }
    }

    nodesToRemove.forEach(function(n){ editor.removeChild(n); });

    // 恢复光标到末尾
    var sel = window.getSelection();
    var range = document.createRange();
    range.selectNodeContents(editor);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
    savedRange = range.cloneRange();
}

$('#script-editor').on('input', function(){
    // 清空残留的 <br>，保证 :empty 伪类生效
    if(this.innerHTML === '<br>' || this.innerHTML === '<div><br></div>') {
        this.innerHTML = '';
    }
    updateCharCount();
});

// 拦截粘贴，只插入纯文本
$('#script-editor').on('paste', function(e){
    e.preventDefault();
    var text = (e.originalEvent || e).clipboardData.getData('text/plain');
    var sel = window.getSelection();
    if(!sel || !sel.rangeCount) return;
    var range = sel.getRangeAt(0);
    range.deleteContents();
    range.insertNode(document.createTextNode(text));
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
    savedRange = range.cloneRange();
    var maxLength = parseInt($('#max-text-count').text()) || 0;
    if(maxLength > 0 && getEditorText().length > maxLength){
        truncateEditor(maxLength);
    }
    updateCharCount();
});

// 保存光标位置（用于插入 chip）
var savedRange = null;
$('#script-editor').on('focus keyup mouseup', function(){
    var sel = window.getSelection();
    if(sel && sel.rangeCount > 0){
        savedRange = sel.getRangeAt(0).cloneRange();
    }
});

function insertChipAtCursor(tag, label){
    var editor = document.getElementById('script-editor');
    editor.focus();

    // 恢复光标
    if(savedRange){
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(savedRange);
    }

    // 创建 chip
    var chip = document.createElement('span');
    chip.className = 'editor-chip';
    chip.setAttribute('data-tag', tag);
    chip.setAttribute('data-label', label);
    chip.setAttribute('contenteditable', 'false');
    chip.innerHTML = label + '<span class="editor-chip-del" data-tag="' + tag + '">×</span>';

    var sel = window.getSelection();
    if(sel && sel.rangeCount > 0){
        var range = sel.getRangeAt(0);
        range.deleteContents();
        range.insertNode(chip);
        // 光标移到 chip 后
        range.setStartAfter(chip);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
        savedRange = range.cloneRange();
    } else {
        editor.appendChild(chip);
    }
    updateCharCount();
}

// 删除 chip
$(document).on('click', '.editor-chip-del', function(e){
    e.stopPropagation();
    $(this).closest('.editor-chip').remove();
    updateCharCount();
});

// chip 编辑浮层 mousedown 阻止编辑器失焦（排除 input，避免阻止其获取焦点）
$('#popup-pause, #popup-tone').on('mousedown', function(e){
    if($(e.target).is('input')) return;
    e.preventDefault();
});

// ---- chip 点击编辑 ----
var $editingChip = null;

function openChipEdit(chip, e){
    e.stopPropagation();
    if($(e.target).hasClass('editor-chip-del')) return;

    $editingChip = $(chip);
    var tag = $editingChip.attr('data-tag');
    var isPause = /^<#/.test(tag);

    if(isPause){
        // 停顿 chip：复用 #popup-pause，高亮当前值
        var cur = tag.replace('<#','').replace('#>','');
        $('#popup-tone').removeClass('active');
        $('#popup-pause .pause-opt').removeClass('pause-opt-active')
            .filter('[data-val="' + cur + '"]').addClass('pause-opt-active');
        $('#popup-pause .pause-custom-input').val('');

        var rect = chip.getBoundingClientRect();
        var $pp = $('#popup-pause');
        $pp.addClass('active');
        var popupH = $pp.outerHeight() || 60;
        var popupW = $pp.outerWidth() || 200;
        safePositionPopup($pp, rect.left, rect.top, rect.bottom, popupW, popupH);
    } else {
        // 语气词 chip：复用 #popup-tone，高亮当前值
        var $popup = $('#popup-tone');
        $('#popup-pause').removeClass('active');
        $popup.find('li').removeClass('active')
            .filter('[data-tag="' + tag + '"]').addClass('active');

        var rect = chip.getBoundingClientRect();
        $popup.addClass('active');
        var popupH = $popup.outerHeight() || 266;
        var popupW = $popup.outerWidth() || 140;
        safePositionPopup($popup, rect.left, rect.top, rect.bottom, popupW, popupH);
    }

    $editingChip.addClass('editing');
}

$(document).on('click', '.editor-chip', function(e){
    openChipEdit(this, e);
});


function closeChipEdit(){
    if($editingChip) $editingChip.removeClass('editing');
    $editingChip = null;
    $('#popup-pause').removeClass('active');
    $('#popup-tone').removeClass('active');
}

// 工具栏按钮 mousedown 阻止编辑器失焦（排除 input，避免阻止其获取焦点）
$('.editor-toolbar').on('mousedown', function(e){
    if($(e.target).is('input')) return;
    e.preventDefault();
});

// ---- 停顿弹窗 ----
$('#btn-pause').on('click', function(e){
    e.stopPropagation();
    var isActive = $('#popup-pause').hasClass('active');
    $('#popup-pause').removeClass('active');
    $('#popup-tone').removeClass('active');
    if(!isActive){
        positionPopupAtCursor($('#popup-pause'));
    }
});

$(document).on('click', '.pause-opt', function(e){
    e.stopPropagation();
    var val = $(this).data('val');
    var tag = '<#' + val + '#>';
    // 高亮选中
    $('#popup-pause .pause-opt').removeClass('pause-opt-active');
    $(this).addClass('pause-opt-active');
    if($editingChip){
        // 编辑模式：更新已有 chip
        $editingChip.attr('data-tag', tag)
            .html(tag + '<span class="editor-chip-del">×</span>');
        closeChipEdit();
        updateCharCount();
    } else {
        insertChipAtCursor(tag, tag);
        $('#popup-pause').removeClass('active');
    }
});

// 自定义停顿：阻止冒泡，回车插入
$(document).on('mousedown click focus', '.pause-custom-input', function(e){ e.stopPropagation(); });
$(document).on('keydown', '.pause-custom-input', function(e){
    e.stopPropagation();
    if(e.key === 'Enter'){
        e.preventDefault();
        var val = parseFloat($(this).val());
        if(isNaN(val) || val < 0.1 || val > 100) return;
        var tag = '<#' + val.toFixed(2).replace(/\.?0+$/, '') + '#>';
        if($editingChip){
            $editingChip.attr('data-tag', tag)
                .html(tag + '<span class="editor-chip-del">×</span>');
            closeChipEdit();
            updateCharCount();
        } else {
            insertChipAtCursor(tag, tag);
        }
        $(this).val('');
        $('#popup-pause').removeClass('active');
    }
});

// ---- 语气词弹窗 ----
$('#btn-tone').on('click', function(e){
    e.stopPropagation();
    var isActive = $('#popup-tone').hasClass('active');
    $('#popup-tone').removeClass('active');
    $('#popup-pause').removeClass('active');
    if(!isActive){
        positionPopupAtCursor($('#popup-tone'));
    }
});

$(document).on('click', '#popup-tone li', function(e){
    e.stopPropagation();
    var tag = $(this).data('tag');
    if($editingChip){
        // 编辑模式：更新已有 chip
        var label = $(this).text();
        $editingChip.attr('data-tag', tag).attr('data-label', label)
            .html(label + '<span class="editor-chip-del">×</span>');
        closeChipEdit();
        updateCharCount();
    } else {
        insertChipAtCursor(tag, $(this).text());
        $('#popup-tone').removeClass('active');
    }
});

// 弹窗定位到光标处
function positionPopupAtCursor($popup){
    var rect = null;
    if(savedRange){
        var tmpRange = savedRange.cloneRange();
        tmpRange.collapse(true);
        rect = tmpRange.getBoundingClientRect();
    }
    $popup.addClass('active');
    var popupW = $popup.outerWidth() || 160;
    var popupH = $popup.outerHeight() || 60;
    var left, anchorTop, anchorBottom;
    if(rect && rect.bottom){
        left = rect.left;
        anchorTop = rect.top;
        anchorBottom = rect.bottom;
    } else {
        var btnId = $popup.attr('id') === 'popup-tone' ? '#btn-tone' : '#btn-pause';
        var btnRect = $(btnId)[0].getBoundingClientRect();
        left = btnRect.left;
        anchorTop = btnRect.top;
        anchorBottom = btnRect.bottom;
    }
    safePositionPopup($popup, left, anchorTop, anchorBottom, popupW, popupH);
}

// anchorTop/anchorBottom: chip或光标的视口top/bottom坐标
function safePositionPopup($popup, left, anchorTop, anchorBottom, popupW, popupH){
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var margin = 8;
    // 左右边界
    if(left + popupW > vw - margin) left = vw - popupW - margin;
    if(left < margin) left = margin;
    // 优先向上弹（弹窗在锚点上方）
    var topAbove = anchorTop - popupH - 6;
    var topBelow = anchorBottom + 6;
    var top;
    if(topAbove >= margin){
        top = topAbove;
    } else if(topBelow + popupH <= vh - margin){
        top = topBelow;
    } else {
        // 上下都放不下，贴顶显示
        top = margin;
    }
    $popup.css({ left: left, top: top });
}

// 点击其他地方关闭弹窗
$(document).on('click', function(){
    $('#popup-pause').removeClass('active');
    $('#popup-tone').removeClass('active');
    $('.pause-custom-input').val('');
    closeChipEdit();
});

// 语气词标签插入（旧逻辑兼容，已废弃）
$(document).on('click', '.tone-tag', function(){
    var tag = $(this).data('tag');
    insertChipAtCursor(tag, tag);
});

$('.btn-generate').click(async function(){
    var text = getEditorText().trim();
    if(!text){
        showToast('Please enter some text to convert.', 'warning');
        return;
    }
    

    var voice_id = $('.voice-info').attr('voice_id');
    if(!voice_id){
        showToast('Please select a voice','warning');
        return;
    }

    // 禁用按钮，防止重复点击
    var $btn = $(this);
    $btn.prop('disabled', true).find('span').text('Generating...');
    
    // 播放条隐藏
    $('.player-bar').removeClass('active')

    $('.btn-svg-lading').addClass('active').siblings('i').removeClass('active');

    if(!getCookie('user')){
        showModal({
            type: 'info',
            title: 'Sign in Required',
            message: 'Please log in to use the Text-to-Speech feature.',
            buttons: [
                {
                    text: 'Log In',
                    type: 'link-blank',
                    href: accountHref + 'login?operation=close',
                    onClick: function(){
                        var loginTimer = setInterval(function(){
                            if(getCookie('user')){
                                clearInterval(loginTimer);
                                is_credit()
                                $('.login_btn>a').click()
                            }
                        }, 1000);
                    }
                },
                {
                    text: 'Cancel',
                    type: 'secondary'
                }
            ]
        });
        
        $('.btn-svg-icon').addClass('active').siblings('i').removeClass('active');
        $btn.prop('disabled', false).find('span').text('Generate Speech');
        return;
    }
    // 领取免费点数
    var credit_use = await credit_use_fn()
    console.log(credit_use)
    if(credit_use){
        if(credit_use['text-to-speech']<credit_use['text_to_speech_max_cost']){
            $.ajaxSettings.async = false;
            benefit_status()
            $.ajaxSettings.async = true;
        }
    }
    // 进行字符校验
    var credit_const = await creditStatus();
    console.log(credit_const);
    if(getEditorText().length > credit_const['total']){
        if(credit_const['total']==0){
            if(credit_const['credit']==0){
                showModal({
                    type: 'info',
                    title: '',
                    message: 'You have used up all your credits. To generate more, please top up your credits.',
                    buttons: [
                        {
                            text: 'Get Credits',
                            type: 'link-blank',
                            href: '/pricing/',
                        },
                        {
                            text: 'Cancel',
                            type: 'secondary'
                        }
                    ]
                });
            }else if(credit_use['text-to-speech']>credit_use['text_to_speech_max_cost']){
                showModal({
                    type: 'info',
                    title: '',
                    message: 'You have used up all your free credits. To generate more, please purchase a TopVox AI plan.',
                    buttons: [
                        {
                            text: 'Get Credits',
                            type: 'link-blank',
                            href: '/pricing/',
                        },
                        {
                            text: 'Cancel',
                            type: 'secondary'
                        }
                    ]
                });
            }else{
                showModal({
                    type: 'info',
                    title: '',
                    message: 'You have used up your free credits for today. You can either come back tomorrow to generate more for free or purchase additional credits now.',
                    buttons: [
                        {
                            text: 'Get Credits',
                            type: 'link-blank',
                            href: '/pricing/',
                        },
                        {
                            text: 'Cancel',
                            type: 'secondary'
                        }
                    ]
                });
            }
        }else{
            showModal({
                type: 'info',
                title: '',
                message: `The number of characters you entered exceeds today's free character limit (${credit_const['text-to-speech']} characters). Please reduce the character count and try again or purchase additional credits now.`,
                buttons: [
                    {
                        text: 'Get Credits',
                        type: 'link-blank',
                        href: '/pricing/',
                    },
                    {
                        text: 'Cancel',
                        type: 'secondary'
                    }
                ]
            });
        }
        
        $('.btn-svg-icon').addClass('active').siblings('i').removeClass('active');
        $btn.prop('disabled', false).find('span').text('Generate Speech');
        return;
    }
    var _startTime = Date.now();
    var _user = JSON.parse(getCookie('user'));
    var _cost = text.length;
    var _signData = await buildSign(_user.e_id, _user.t_id, _user.token);
    $.ajax({
        url: '/api/account/text-to-speech/',
        type: 'POST',
        data: {
            // 会员
            e_id: _user.e_id,
            t_id: _user.t_id,
            token: _user.token,
            product_id:product_id,
            key:'text-to-speech',
            cost: _cost,
            timestamp: _signData.timestamp,
            sign: _signData.sign,
            // 转换
            text: text,
            voice_id: voice_id,
            speed: $('.speed_slider').val()*1,
            pitch: $('.pitch_slider').val()*1,
            vol: $('.volume_slider').val()*1,
        },
        success: function(response){
            if (response.error==0) {
                var audioSrc = 'data:audio/' + response.format + ';base64,' + response.audio;
                updatePlayerState(null, audioSrc, response.format, $btn);
            } else if (response.error === 1007) {
                showToast('You have used up your free character count.', 'warning');
                $('.btn-svg-icon').addClass('active').siblings('i').removeClass('active');
                $btn.prop('disabled', false).find('span').text('Generate Speech');
            } else {
                showToast('Failed to generate speech. Please try again later or contact our <a href="mailto:support@topvox.ai">support team</a>.','error');
                $('.btn-svg-icon').addClass('active').siblings('i').removeClass('active');
                $btn.prop('disabled', false).find('span').text('Generate Speech');
            }
        },
        error: function(){
            showToast('Failed to generate speech. Please try again later or contact our <a href="mailto:support@topvox.ai">support team</a>.','error');
            $('.btn-svg-icon').addClass('active').siblings('i').removeClass('active');
            $btn.prop('disabled', false).find('span').text('Generate Speech');
        },
        complete: function(){
            manage('text_to_speech_convert_time',((Date.now() - _startTime) / 1000).toFixed(2) + 's')
        }
    });
})



// 更新播放器状态
function updatePlayerState(audio, audioSrc, format, $btn) {
    currentAudioFormat = format;
    
    // 播放条展示 
    $('.player-bar').addClass('active');
    
    // 恢复按钮状态
    $('.btn-svg-icon').addClass('active').siblings('i').removeClass('active');
    if ($btn) {
        $btn.prop('disabled', false).find('span').text('Generate Speech');
    }
    
    // 更新下载按钮
    $('.player-actions .btn-icon-lg').off('click').on('click', function(){
        if (!currentAudioSrc) {
            showToast('请先生成音频', 'warning');
            return;
        }
        var downloadLink = document.createElement('a');
        downloadLink.href = currentAudioSrc;
        downloadLink.download = 'tts_' + Date.now() + '.' + currentAudioFormat;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    });
    
    // 更新 HTML5 audio 播放器（用 Blob URL 替代 Data URL，加载更快）
    var audioPlayer = document.getElementById('audio-player');
    // 释放上一个 Blob URL
    if (audioPlayer._blobUrl) {
        URL.revokeObjectURL(audioPlayer._blobUrl);
        audioPlayer._blobUrl = null;
    }
    // base64 转 Blob
    var base64Data = audioSrc.split(',')[1];
    var mimeType = 'audio/' + format;
    var byteChars = atob(base64Data);
    var byteArray = new Uint8Array(byteChars.length);
    for (var i = 0; i < byteChars.length; i++) {
        byteArray[i] = byteChars.charCodeAt(i);
    }
    var blob = new Blob([byteArray], { type: mimeType });
    var blobUrl = URL.createObjectURL(blob);
    audioPlayer._blobUrl = blobUrl;
    audioPlayer.src = blobUrl;
    currentAudioSrc = blobUrl;
    
    // 自动播放
    // audioPlayer.play();
}

// 格式化时间
function formatTime(seconds) {
    if (isNaN(seconds)) return '00:00';
    var mins = Math.floor(seconds / 60);
    var secs = Math.floor(seconds % 60);
    return (mins < 10 ? '0' : '') + mins + ':' + (secs < 10 ? '0' : '') + secs;
}


$('.speed_slider').on('input', function(){
    var speed = $(this).val();
    if(speed==1 || speed==2){
        speed=speed+'.0'
    }
    $('.speed_display').text(speed + 'x');
})
$('.pitch_slider').on('input', function(){
    var pitch = $(this).val();
    $('.pitch_display').text(pitch);
})
$('.volume_slider').on('input', function(){
    var volume = $(this).val();
    var volumeFormatted = parseFloat(volume).toFixed(1);
    $('.volume_display').text(volumeFormatted);
})

function benefit_status(){
    $.post(
        post_url+'credit/reward',
        {
            e_id:JSON.parse(getCookie('user')).e_id,
            t_id:JSON.parse(getCookie('user')).t_id,
            token:JSON.parse(getCookie('user')).token,
            key:'text-to-speech'
        },
        function(data){
            error_fn(data.error)
            switch(data.error){
                case 0:
                    // 记录领取时间
                    // localStorage.setItem('lastRewardTime', currentTime.toString());
                    break;
            }
        }
    )
}
// 查询积分，返回 Promise<number>
function creditStatus(){
    return new Promise(function(resolve, reject){
        $.post(
            post_url+'credit/status',
            {
                e_id:JSON.parse(getCookie('user')).e_id,
                t_id:JSON.parse(getCookie('user')).t_id,
                token:JSON.parse(getCookie('user')).token
            },
            function(data){
                error_fn(data.error)
                console.log(data);
                var balance={total:0}
                switch(data.error){
                    case 0:
                        data.credits.forEach(function(item){
                            var val = item.balance*1;
                            balance[item.name] = (balance[item.name] || 0) + val;
                            balance.total += val;
                        });
                        break;
                    case 27801:
                        error(i18n[lang].error_27801);
                        break;
                }
                console.log(balance)
                resolve(balance);
            }
        ).error(function(xhr){
            overtime(27899);
            reject(xhr);
        });
    });
}
// 查询使用积分记录
async function credit_use_fn(){
    var _user = JSON.parse(getCookie('user'));
    var _signData = await buildSign(_user.e_id, _user.t_id, _user.token);
    return new Promise(function(resolve){
        $.post(
            '/api/account/credit_use',
            {
                account_id: _user.t_id,
                e_id:       _user.e_id,
                t_id:       _user.t_id,
                token:      _user.token,
                timestamp:  _signData.timestamp,
                sign:       _signData.sign,
            },
            function(data){
                if(data.error==0){
                    resolve(data['balance']);
                }else{
                    overtime(data.error);
                    resolve(false);
                }
            }
        ).error(function(xhr){
            overtime(27899);
            console.log(xhr)
            resolve(false);
        });
    });
};
// 将 #script-editor 的 max-height 设置为其当前实际高度
$(function(){
    var $editor = $('#script-editor');
    $editor.css('max-height', $editor.height() + 'px');
});
async function is_credit(){
    if(getCookie('user')){
        var credit= await creditStatus() 
        if(credit['credit']){
            $('#max-text-count').html('4000')
        }
    }
}
// 判断是否为购买用户
userProfileFn.push(is_credit)